import { Option } from 'types/select';

const TREATMENT_PLAN_TYPE: Option[] = [
  {
    label: 'prescriptions.zenyumclear',
    value: 'ZenClear'
  },
  {
    label: 'prescriptions.zenyumclear_plus',
    value: 'ZenPlus'
  },
  {
    label: 'refinement.zenyumclear',
    value: 'ZenClearRefinement'
  },
  {
    label: 'refinement.zenyumclear_plus',
    value: 'ZenPlusRefinement'
  },
  {
    label: 'prescriptions.zenyumclear_ultra',
    value: 'ZenClearUltra'
  },
  {
    label: 'refinement.zenyumclear_ultra',
    value: 'ZenClearUltraRefinement'
  }
];
export const TREATMENT_PLAN_TYPE_MAP = {
  ZenClear: {
    label: 'prescriptions.zenyumclear',
    value: 'ZenClear'
  },
  ZenPlus: {
    label: 'prescriptions.zenyumclear_plus',
    value: 'ZenPlus'
  },
  ZenClearRefinement: {
    label: 'refinement.zenyumclear',
    value: 'ZenClearRefinement'
  },
  ZenPlusRefinement: {
    label: 'refinement.zenyumclear_plus',
    value: 'ZenPlusRefinement'
  },
  ZenClearUltra: {
    label: 'prescriptions.zenyumclear_ultra',
    value: 'ZenClearUltra'
  },
  ZenClearUltraRefinement: {
    label: 'refinement.zenyumclear_ultra',
    value: 'ZenClearUltraRefinement'
  }
};
export const preferenceTypes = ['ZenClear', 'ZenPlus', 'Refinement'];
const IPR_OPTIONS: Option[] = [
  {
    label: '0.1',
    value: '0.1'
  },
  {
    label: '0.2',
    value: '0.2'
  },
  {
    label: '0.3',
    value: '0.3'
  },
  {
    label: '0.4',
    value: '0.4'
  },
  {
    label: '0.5',
    value: '0.5'
  },
  {
    label: 'ipr.locations.no.preferences',
    value: 'no Preferences'
  }
];

const IPR_LOCATION: Option[] = [
  {
    label: '2-2',
    value: '2-2'
  },
  {
    label: '3-3',
    value: '3-3'
  },
  {
    label: '4-4',
    value: '4-4'
  },
  {
    label: '5-5',
    value: '5-5'
  },
  {
    label: '6-6',
    value: '6-6'
  }
];
const BITE_RAMP: Option[] = [
  {
    label: 'biteRamp.when.possible',
    value: 'When possible'
  },
  {
    label: 'biteRamp.never',
    value: 'Never'
  }
];
const PREMOLAR_CROSSBITE: Option[] = [
  {
    label: 'premolar.crossbite.attachment',
    value: 'Attachment only'
  },
  {
    label: 'premolar.crossbite.elastics',
    value: 'Elastics only'
  },
  {
    label: 'premolar.crossbite.attachment.elastics',
    value: 'Attachment & elastics'
  },
  {
    label: 'premolar.crossbite.no.correction',
    value: 'No correction'
  }
];

export const preferenceTypesName: Record<string, string> = {
  ZenClear: 'prescriptions.zenyumclear',
  ZenPlus: 'prescriptions.zenyumclear_plus',
  ZenClearRefinement: 'refinement.zenyumclear',
  ZenPlusRefinement: 'refinement.zenyumclear_plus',
  ZenClearUltra: 'prescriptions.zenyumclear_ultra',
  ZenClearUltraRefinement: 'refinement.zenyumclear_ultra'
};
export {
  TREATMENT_PLAN_TYPE,
  IPR_OPTIONS,
  IPR_LOCATION,
  BITE_RAMP,
  PREMOLAR_CROSSBITE
};
